import { SVGComponentPropsType } from 'assets/types';
import colors from 'styles/colors';

const defaultSize = 12;

const ClosedStatusIcon = ({
  size = defaultSize,
  color = colors.agreementStatusClosed,
  ...props
}: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <rect x="9" y="6" width="12" height="12" rx="2" transform="translate(-9 -6)" fill={color} fillRule="evenodd" />
  </svg>
);

export default ClosedStatusIcon;
